'use client'
import { SbBlokData, storyblokEditable, StoryblokServerComponent } from '@storyblok/react/rsc'
import { FC } from 'react'

import { AccordionitemProps, PhnxAccordionitem } from '../Accordionitem/Accordionitem'

interface AccordionitemBlokProps {
  blok: {
    title: AccordionitemProps['title']
    content: SbBlokData[]
    variant: AccordionitemProps['variant']
  } & SbBlokData
}

const Accordionitem: FC<AccordionitemBlokProps> = ({ blok }) => {
  return (
    <div {...storyblokEditable(blok)}>
      <PhnxAccordionitem
        title={blok.title}
        variant={blok.variant || 'primary'}
        content={
          blok.content && blok.content.length > 0
            ? blok.content.map((nestedBlok: SbBlokData) => (
                <StoryblokServerComponent blok={nestedBlok} key={nestedBlok._uid} />
              ))
            : null
        }
      />
    </div>
  )
}

export default Accordionitem
